import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './unit.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Unit } from "model/dealer/unit.model";

export interface UnitDetailsProps extends DetailsStateAndDispatchProps<Unit>,
  RouteComponentProps, StateProps, DispatchProps {
}
const UnitDetails: FC<UnitDetailsProps> = (props) => {
  return (
    <DetailsPage<Unit>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Unit>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ unit }: RootState) => ({
  entity: unit.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(UnitDetails);
